<template>
  <Card>
    <AjaxForm  :callback="editCallback" :route="'admin/MarketRequest/Edit/'+req._id" v-if="req">
    <div class="row" >
      <div class="col-12 col-sm-6 col-md-3 mb-3">
        <label>شماره درخواست : {{req.number}}</label>
      </div>
      <div class="col-12 col-sm-6 col-md-3 mb-3">
        درخواست دهنده :
        {{req.user_id.title}}
        ({{req.user_id.phone}})
      </div>
      <div class="col-12 col-sm-6 col-md-3 mb-3">
        <label>تاریخ ثبت : </label>
        {{req.createdAt}}
      </div>
      <div class="col-12 col-sm-6 col-md-3 mb-3">
        <label>محصول : </label>
        {{req.product_title}}
      </div>
      <div class="col-12 col-sm-6 col-md-3 mb-3">
        <label>ویژگی ها :</label>
        <span>{{req.attributes}}</span>
      </div>
      <div class="col-12 col-sm-6 col-md-3 mb-3">
        <label>شرایط پرداخت :</label>
        <span v-for="(p,index) in req.pay_condition" :key="p">{{p.title}}<i v-if="(index !== (req.pay_condition.length-1))"> ، </i></span>
      </div>
      <div class="col-12 col-sm-6 col-md-3 mb-3">
        <label>برند :
        </label> <span> {{req.brand_title}}</span>
      </div>
      <div class="col-12 col-sm-6 col-md-3 mb-3">
        <label>کشور :
        </label> <span> {{req.country_title}}</span>
      </div>
      <div class="col-12 col-sm-6 col-md-3 mb-3">
        <label>تاریخ اعتبار:
        {{req.credit_date}}
        </label>
      </div>
      <div class="col-12 col-sm-6 col-md-3 mb-3">
        <label>توضیحات برای پیشنهاد دهندگان :</label>
        <div>{{req.description}}</div>
      </div>
      <div class="col-12 col-sm-12 col-md-3 mb-3">
        <label>آخرین ویرایش کننده : </label>
        <div v-if="req.last_edit_user_id">
          <div>{{req.last_edit_user_id.fullname}}</div>
          <div>{{req.last_edit}}</div>
        </div>
        <div v-else>--</div>
      </div>
      <div v-if="req.priority" class="col-12 col-sm-12 col-md-3 mb-3">
        <label>اولویت خریدار : </label>&nbsp;&nbsp;
       <span v-if="req.priority === 'price'"><i class="far fa-money-bill"></i> قیمت محصول می باشد</span>
       <span v-if="req.priority === 'quality'"><i class="far fa-hundred-points"></i>&nbsp;کیفیت محصول می باشد</span>
      </div>
      <div class="col-12 col-sm-12 col-md-3 mb-3">
        <label>مایل به پیشنهاد سایر برندها :</label>&nbsp;
        <span v-if="req.use_other_brands" class="text-success font-weight-bold">می باشد</span>
        <span v-else class="text-danger font-weight-bold">نمی باشد</span>
      </div>
      <div class="col-12 col-sm-12 col-md-3 mb-3" v-if="req.status === 'confirmed'">
        <label>تاریخ آخرین انتشار :
        </label>
        <div>{{req.publish_date}}</div>
      </div>
      <div class="col-12 col-sm-12 col-md-3 mb-3" v-if="req.status === 'confirmed'">
        <label>تاریخ تایید :
        </label>
        <div>{{req.confirm_date}}</div>
      </div>
      <div class="col-12 col-sm-6 col-md-3 mb-3">
        <CustomInput :not-select-append-to-body="!!request_id" v-if="req.status ==='waiting' || req.status === 'confirmed'" input_style="twoLine"
                     type="select" name="status"
                     :select-options="statuses"
                     v-model="select_status"
                     reduce_select="value"
                     placeholder="وضعیت را انتخاب کنید"
                     select-label="title"
                     label="انتخاب وضعیت"></CustomInput>
        <div v-else-if="req.status === 'denied'" class="text-danger">وضعیت : رد شده توسط مدیر</div>
        <div v-else-if="req.status === 'finished'" class="text-success">وضعیت : تمام شده</div>
        <div v-else-if="req.status === 'canceled'" class="text-danger">وضعیت : لغو شده توسط کاربر</div>
        <div v-else-if="req.status === 'expired'" class="text-danger">وضعیت : منقضی شده</div>
      </div>
      <div class="col-12 col-sm-12 col-md-8 mb-3">
        <CustomInput v-if="req.status ==='waiting' || req.status === 'confirmed'" input_style="twoLine" type="textarea" name="deny_reason" placeholder="دلیل رد کردن..."
                     label="دلیل رد درخواست :"
                     v-model="req.deny_reason"
        ></CustomInput>
        <div v-else-if="req.deny_reason">دلیل رد کردن درخواست :
          {{req.deny_reason}}
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-3 mb-3"></div>
    </div>
      <div class="row">
        <div v-if="req.status ==='waiting' || req.status === 'confirmed'" class="col-10 col-sm-8 col-md-5 mx-auto">
          <button class="btn btn-info btn-block">ویرایش درخواست</button>
        </div>
      </div>
      <div class="h4">پیشنهادها</div>
      <LocalDataTable :init-document="is_mounted" :functions="functions" :columns="columns" :order-column="0" :order-type="1" :ajax-link="ajaxLink"></LocalDataTable>
    </AjaxForm>
    <div class="alert alert-danger" v-if="error">
      {{error}}
    </div>
    <div ref="ttt" class="d-none">
      <MarketRequestOfferInfoModal :offer="offer"></MarketRequestOfferInfoModal>
    </div>
  </Card>
</template>

<script>
import Card from "@/components/forms/Card";
import {mapActions} from "vuex";
import {AppApi} from "@/api/AppApi";
import {date, dateInput, findSelectItem, printMoney, showSystemNoti, sleep} from "@/shared/helper";
import CustomInput from "@/components/CustomInput";
import AjaxForm from "@/components/forms/AjaxForm";
import LocalDataTable from "@/components/LocalDataTable";
import MarketRequestOfferInfoModal from "@/components/MarketRequestOfferInfoModal";
import Swal from "sweetalert2";
let mounted = false;
export default {
name: "MarketRequestEdit",
  components: {LocalDataTable, AjaxForm, CustomInput, Card,MarketRequestOfferInfoModal},
  props:['request_id'],
  data()
  {
    return{
      offer : null,
      is_mounted : mounted,
      id : this.$route.params.id,
      req : null,
      error : null,
      statuses : [
        {title :'درانتظار بررسی',value : 'waiting'},
        {title :'تایید شده',value : 'confirmed'},
        {title :'رد شده',value : 'denied'},
      ],
      select_status :null,
      columns:[
        {title : 'شماره'},
        {title : 'فروشنده'},
        {title : 'تاریخ ایجاد'},
        {title : 'محصول'},
        {title : 'ویژگی'},
        {title : 'وضعیت'},
        {title : '<i class="far fa-cogs"></i>'},
      ],
      ajaxLink :'admin/MarketRequestOffer/List',
      functions : [{name : 'showOfferInfo',method: this.showOfferInfo}]
    }
  },
  mounted()
  {
    if (!this.request_id)
    {
      this.setPageLoading(false);
      this.setPageTitle('مشاهده درخواست بازار');
      this.setShowHead(true);
    }
    this.is_mounted = mounted;
    mounted = true;
    this.initPage();
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
    async initPage()
    {
      this.setPageLoading(true);
      this.error = null;
      this.req = null;
      this.id = this.$route.params.id;
      if (!this.id && this.request_id)
      {
        this.id = this.request_id;
      }
      const result = await AppApi.getMarketRequestInfoForEdit(this.id);
      if (result.ok)
      {
        this.ajaxLink = 'admin/MarketRequestOffer/List/'+this.id;
        this.req = result.req;
        this.req.createdAt = date(this.req.createdAt,true);
        this.req.credit_date = date(this.req.credit_date);
        this.req.last_edit = date(this.req.last_edit_date,true);
        if (this.req.publish_date)
          this.req.publish_date = date(this.req.publish_date,true);
        if (this.req.confirm_date)
          this.req.confirm_date = date(this.req.confirm_date,true);
        this.select_status = findSelectItem(this.req.status,this.statuses,'value');
      }
      else
        this.error = result.error;
      this.setPageLoading(false);
    },
    async editCallback(data)
    {
      const self = this;
      if (data.ok)
      {
        showSystemNoti('success',data.message,function (){
          self.initPage();
        });
      }
      else
        showSystemNoti('danger',data.error);
    },
    async showOfferInfo(id,element)
    {
      this.setPageLoading(true);
      const result = await AppApi.getMarketRequestOfferInfo(id);
      if (result.ok)
      {
        this.offer = result.offer;
        const self = this;
        const h = this.$refs.ttt;
        setTimeout(function ()
        {
          Swal.fire({
            html: (h?h.innerHTML:''),
            width: '1000px',
            showCancelButton: false,
            showConfirmButton: false,
            showCloseButton: true,
          }).then((result)=>{
            if (result.isDismissed)
            {
              self.offer = null;
            }
          })
        },100)
      }
      else
        showSystemNoti('danger',result.error);
      this.setPageLoading(false);
    }
  }
}
</script>

<style scoped>

</style>